import React, {createContext, useContext, useEffect, useState} from 'react'
import {useAuth2} from '../../modules/authv2/Auth2Provider'
import {getProcessesForDropdown} from '../../services/procesos'
import {getUnitsByRole} from '../../services/users'

// Here you should initialize everything that has to do with the user,
// and basic things like processes and units by role

interface ProceosResponse {
  id: string
  isOffBoarding: boolean
  isOnboarding: boolean
  isPostulacion: boolean
  isRegular: boolean
  name: string
  unidad: string
  descripcion: string
}

interface UnidadesResponse {
  id: string
  name: string
}

interface InfoUserContextProps {
  unidadesAdmin: UnidadesResponse[]
  procesosAdmin: ProceosResponse[]
  procesosGrouped: Record<string, ProceosResponse[]>
  unidadesGrouped: Record<string, UnidadesResponse[]>
}

export const InfoUserContext = createContext<InfoUserContextProps>({
  procesosAdmin: [],
  unidadesAdmin: [],
  procesosGrouped: {},
  unidadesGrouped: {},
})

interface InfoUserProviderProps {
  children: React.ReactNode
}

export const InfoUserProvider: React.FC<InfoUserProviderProps> = ({children}) => {
  const {selectedCompanyId, selectedRole} = useAuth2()

  const [unidadesAdmin, setUnidades] = useState<UnidadesResponse[]>([])
  const [procesosAdmin, setProcesos] = useState<ProceosResponse[]>([])

  useEffect(() => {
    getUnitsByRole()
      .then((response) => {
        if (response.success) {
          setUnidades(response.data)
        } else {
          console.log(response.message)
        }
      })
      .catch(console.log)

    getProcessesForDropdown()
      .then((response) => {
        if (response.success) {
          setProcesos(response.data)
        } else {
          console.log(response.message)
        }
      })
      .catch(console.log)
  }, [selectedCompanyId, selectedRole])

  const transversales = procesosAdmin.filter((p) => !p.unidad || p.unidad === '')
  const procesosGrouped = unidadesAdmin.reduce(
    (acc: Record<string, ProceosResponse[]>, u) => {
      const procesosByUnit = procesosAdmin.filter((p) => p.unidad === u.id)
      if (acc[u.id]) {
        if (Array.isArray(procesosByUnit)) acc[u.id].concat(procesosByUnit)
      } else {
        if (Array.isArray(procesosByUnit)) acc[u.id] = procesosByUnit
      }

      return acc
    },
    {transversales}
  )
  const unidadesGrouped = procesosAdmin.reduce(
    (acc: Record<string, UnidadesResponse[]>, proceso) => {
      if (proceso.unidad) {
        const unidadObj = unidadesAdmin.find((u) => u.id === proceso.unidad)
        acc[proceso.id] = unidadObj ? [unidadObj] : []
      } else {
        acc[proceso.id] = [...unidadesAdmin]
      }
      return acc
    },
    {}
  )

  return (
    <InfoUserContext.Provider
      value={{
        unidadesAdmin,
        procesosAdmin,
        procesosGrouped,
        unidadesGrouped,
      }}
    >
      {children}
    </InfoUserContext.Provider>
  )
}

export const useUserInfo = () => useContext(InfoUserContext)
